


// import React, { useState, useEffect } from "react";
// import { useSelector, useDispatch } from 'react-redux';
// import { selectUser, addProperty, incrementPropertyCount } from '../Commonlibs/userSlice';
// import { useNavigate, useLocation } from 'react-router-dom';
// import {
//   Box,
//   Button,
//   Card,
//   CardContent,
//   Container,
//   Dialog,
//   DialogTitle,
//   DialogContent,
//   DialogContentText,
//   DialogActions,
//   Divider,
//   TextField,
//   Typography,
//   useTheme,
//   useMediaQuery,
//   InputAdornment,
//   CircularProgress,
// } from "@mui/material";
// import {
//   Check as CheckIcon,
//   Phone,
//   Email,
//   Person,
// } from "@mui/icons-material";
// import Loader from '../Loader/Loader';

// const PriceDetails = () => {
//   const theme = useTheme();
//   const isMobile = useMediaQuery(theme.breakpoints.down("md"));
//   const navigate = useNavigate();
//   const location = useLocation();
//   const user = useSelector(selectUser);
//   const dispatch = useDispatch();

//   // State variables for form data
//   const [askingPrice, setAskingPrice] = useState(() => localStorage.getItem('price_askingPrice') || '');
//   const [askingPriceError, setAskingPriceError] = useState('');
//   const [currency, setCurrency] = useState(() => localStorage.getItem('price_currency') || '₹');
//   const [constructionStatus, setConstructionStatus] = useState(() => localStorage.getItem('price_constructionStatus') || 'ready to move');
//   const [negotiable, setNegotiable] = useState(() => localStorage.getItem('price_negotiable') === 'false' ? false : true);

//   // State for loading and alerts
//   const [loading, setLoading] = useState(false);
//   const [alert, setAlert] = useState({ open: false, message: '', severity: 'success' });

//   // ✅ Profile verification states (NO OTP)
//   const [profileData, setProfileData] = useState(null);
//   const [loadingProfile, setLoadingProfile] = useState(true);
//   const [showVerificationDialog, setShowVerificationDialog] = useState(false);
//   const [verificationForm, setVerificationForm] = useState({
//     fullName: '',
//     email: '',
//     contactNumber: '',
//   });
//   const [verificationErrors, setVerificationErrors] = useState({});
//   const [verificationLoading, setVerificationLoading] = useState(false);

//   // Get data from previous screens
//   const { propertyType, category, ...otherProps } = location.state || {};

//   // ✅ NEW: Clear all form data function
//   const clearAllFormData = () => {
//     // Clear PriceDetails form data
//     setAskingPrice('');
//     setCurrency('₹');
//     setConstructionStatus('ready to move');
//     setNegotiable(true);
    
//     // Clear all localStorage items
//     localStorage.removeItem('price_askingPrice');
//     localStorage.removeItem('price_currency');
//     localStorage.removeItem('price_constructionStatus');
//     localStorage.removeItem('price_negotiable');
//     localStorage.removeItem('propertyDetailsFormState');
//     localStorage.removeItem('propertyType');
//     localStorage.removeItem('category');
//     localStorage.removeItem('propertyLocation');
    
//     // Clear errors
//     setAskingPriceError('');
//   };

//   // ✅ Fetch user profile data on mount
//   useEffect(() => {
//     const fetchUserProfile = async () => {
//       const userId = user?.id;
//       if (!userId) {
//         setLoadingProfile(false);
//         return;
//       }

//       try {
//         setLoadingProfile(true);
//         const response = await fetch(`https://propertydealstalk.com/api/users/getUserProfile?user_id=${userId}`);
//         const data = await response.json();

//         if (data.status === "SUCCESS") {
//           setProfileData(data.result);
//         }
//       } catch (err) {
//         console.error('Error fetching profile:', err);
//       } finally {
//         setLoadingProfile(false);
//       }
//     };

//     fetchUserProfile();
//   }, [user?.id]);

//   // Helper function to format number with Indian comma system
//   const formatIndianNumber = (num) => {
//     if (!num) return '';
//     const numStr = num.toString();
//     const lastThree = numStr.substring(numStr.length - 3);
//     const otherNumbers = numStr.substring(0, numStr.length - 3);
//     if (otherNumbers !== '') {
//       return otherNumbers.replace(/\B(?=(\d{2})+(?!\d))/g, ",") + "," + lastThree;
//     }
//     return lastThree;
//   };

//   // Helper function to convert number to words (Indian system)
//   const convertToWords = (num) => {
//     if (!num || num === '0') return '';

//     const ones = ['', 'One', 'Two', 'Three', 'Four', 'Five', 'Six', 'Seven', 'Eight', 'Nine'];
//     const teens = ['Ten', 'Eleven', 'Twelve', 'Thirteen', 'Fourteen', 'Fifteen', 'Sixteen', 'Seventeen', 'Eighteen', 'Nineteen'];
//     const tens = ['', '', 'Twenty', 'Thirty', 'Forty', 'Fifty', 'Sixty', 'Seventy', 'Eighty', 'Ninety'];

//     const numToWords = (n) => {
//       if (n < 10) return ones[n];
//       if (n < 20) return teens[n - 10];
//       if (n < 100) return tens[Math.floor(n / 10)] + (n % 10 ? ' ' + ones[n % 10] : '');
//       return ones[Math.floor(n / 100)] + ' Hundred' + (n % 100 ? ' ' + numToWords(n % 100) : '');
//     };

//     const crore = Math.floor(num / 10000000);
//     const lakh = Math.floor((num % 10000000) / 100000);
//     const thousand = Math.floor((num % 100000) / 1000);
//     const hundred = num % 1000;

//     let result = '';
//     if (crore > 0) result += numToWords(crore) + ' Crore ';
//     if (lakh > 0) result += numToWords(lakh) + ' Lakh ';
//     if (thousand > 0) result += numToWords(thousand) + ' Thousand ';
//     if (hundred > 0) result += numToWords(hundred);

//     return result.trim();
//   };

//  const handleBack = () => {
//   // ✅ Pass back ALL state including asset_type
//   navigate('/property-details', { 
//     state: { 
//       propertyType: propertyType || location.state?.propertyType,
//       category: category || location.state?.category,
//       location: location.state?.location || '',
//       // ✅ CRITICAL: Include asset_type and selectedType
//       asset_type: location.state?.asset_type || '',
//       selectedType: location.state?.selectedType || '',
//       // ✅ Pass all other state back
//       ...location.state
//     } 
//   });
// };
//   // Save form values to localStorage whenever they change
//   useEffect(() => {
//     localStorage.setItem('price_askingPrice', askingPrice);
//     localStorage.setItem('price_currency', currency);
//     localStorage.setItem('price_constructionStatus', constructionStatus);
//     localStorage.setItem('price_negotiable', negotiable.toString());
//   }, [askingPrice, currency, constructionStatus, negotiable]);

//   // Progress steps
//   const progressSteps = [
//     { label: "Basic Details", completed: true },
//     { label: "Property Details", completed: true },
//     { label: "Price Details", completed: false, current: true },
//   ];

//   // Validate asking price
//   const validateAskingPrice = (value) => {
//     if (!value || value.trim() === '') {
//       setAskingPriceError('Property cost is required');
//       return false;
//     }

//     const priceRegex = /^[1-9]\d*$/;
//     if (!priceRegex.test(value)) {
//       setAskingPriceError('Please enter a valid whole number amount (e.g., 5000000)');
//       return false;
//     }

//     const amount = parseInt(value, 10);
//     if (amount < 100000) {
//       setAskingPriceError('Property cost must be at least 1 lakh');
//       return false;
//     }

//     if (amount > 10000000000) {
//       setAskingPriceError('Property cost cannot exceed 1000 crores');
//       return false;
//     }

//     setAskingPriceError('');
//     return true;
//   };

//   // Handle asking price change with input validation
//   const handleAskingPriceChange = (e) => {
//     const value = e.target.value;
//     if (value === '' || /^[0-9]*$/.test(value)) {
//       setAskingPrice(value);
//       validateAskingPrice(value);
//     }
//   };

//   // ✅ Validation functions for verification form
//   const validateVerificationField = (name, value) => {
//     if (!value || value.trim() === '' || value === 'N/A') {
//       return `${name} is required`;
//     }

//     switch (name) {
//       case 'fullName':
//         return /^[A-Za-z\s]{2,50}$/.test(value)
//           ? ''
//           : 'Name should contain only letters and spaces (2-50 characters)';
//       case 'email':
//         return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)
//           ? ''
//           : 'Please enter a valid email address';
//       case 'contactNumber':
//         return /^\d{10}$/.test(value)
//           ? ''
//           : 'Phone number should be 10 digits';
//       default:
//         return '';
//     }
//   };

//   // ✅ Handle verification form changes
//   const handleVerificationChange = (field, value) => {
//     setVerificationForm(prev => ({ ...prev, [field]: value }));
//     if (verificationErrors[field]) {
//       setVerificationErrors(prev => ({ ...prev, [field]: '' }));
//     }
//   };

//   // ✅ Handle phone number input (only digits)
//   const handlePhoneNumberChange = (e) => {
//     const value = e.target.value;
//     if (value === '' || (/^\d+$/.test(value) && value.length <= 10)) {
//       handleVerificationChange('contactNumber', value);
//     }
//   };

//   // ✅ Update user profile (NO OTP - Direct Update)
//   const updateUserProfile = async () => {
//     setVerificationLoading(true);
//     try {
//       const formDataToSend = new FormData();
//       formDataToSend.append('user_id', user?.id);
//       formDataToSend.append('full_name', verificationForm.fullName);
//       formDataToSend.append('email_id', verificationForm.email);
//       formDataToSend.append('contact_number', verificationForm.contactNumber);

//       const response = await fetch('https://propertydealstalk.com/api/users/UpdateUserprofile', {
//         method: 'POST',
//         body: formDataToSend,
//       });

//       const data = await response.json();

//       if (data.status === "SUCCESS") {
//         setProfileData(data.result);
//         setShowVerificationDialog(false);

//         // Proceed with property upload
//         setTimeout(() => {
//           performPropertyUpload();
//         }, 500);
//       } else {
//         setAlert({
//           open: true,
//           message: data.message || 'Failed to update profile',
//           severity: 'error'
//         });
//       }
//     } catch (error) {
//       console.error('Profile update error:', error);
//       setAlert({
//         open: true,
//         message: 'Failed to update profile. Please try again.',
//         severity: 'error'
//       });
//     } finally {
//       setVerificationLoading(false);
//     }
//   };

//   // ✅ Handle verification submit (Direct - No OTP)
//   const handleVerificationSubmit = async () => {
//     // Validate all fields
//     const newErrors = {};
//     Object.keys(verificationForm).forEach(key => {
//       const error = validateVerificationField(key, verificationForm[key]);
//       if (error) newErrors[key] = error;
//     });

//     if (Object.keys(newErrors).length > 0) {
//       setVerificationErrors(newErrors);
//       return;
//     }

//     // Direct profile update without OTP
//     await updateUserProfile();
//   };

//   // ✅ Handle property upload - check profile first
//   const handleUploadProperty = async () => {
//     // Validate all fields before submission
//     const isPriceValid = validateAskingPrice(askingPrice);

//     if (!isPriceValid) {
//       setAlert({
//         open: true,
//         message: 'Please fix the errors before submitting',
//         severity: 'error'
//       });
//       return;
//     }

//     // ✅ Check if user profile needs verification
//     const needsVerification =
//       !profileData?.full_name ||
//       profileData.full_name === 'N/A' ||
//       !profileData?.email_id ||
//       profileData.email_id === 'N/A' ||
//       !profileData?.contact_number ||
//       profileData.contact_number === 'N/A';

//     if (needsVerification) {
//       // Initialize verification form with available data
//       setVerificationForm({
//         fullName: profileData?.full_name && profileData.full_name !== 'N/A' ? profileData.full_name : '',
//         email: profileData?.email_id && profileData.email_id !== 'N/A' ? profileData.email_id : '',
//         contactNumber: profileData?.contact_number && profileData.contact_number !== 'N/A' ? profileData.contact_number : '',
//       });
//       setShowVerificationDialog(true);
//       return;
//     }

//     // Profile is complete, proceed with upload
//     await performPropertyUpload();
//   };

//   // ✅ Actual property upload logic
//   const performPropertyUpload = async () => {
//     setLoading(true);
//     try {
//       // Validate required fields
//       if (!askingPrice || !currency || !constructionStatus) {
//         setAlert({
//           open: true,
//           message: 'Please fill all required fields',
//           severity: 'error'
//         });
//         setLoading(false);
//         return;
//       }

//       // Get user ID from Redux store
//       const userId = user?.id;
//       if (!userId) {
//         throw new Error('User not authenticated');
//       }

//       // Determine property type details
//       const assetType = location.state?.asset_type || '';
//       const selectedType = location.state?.selectedType || '';

//       // Enhanced detection for Plot and Agriculture Land property types
//       const isplot = assetType === 'plot' || selectedType === 'plot';
//       const isAgricultureLand = assetType.toLowerCase() === 'agriculture land' || selectedType === 'agriculture-land';
//       const isCommercial = propertyType === 'Commercial';

//       // Create a FormData object for the API call
//       const formData = new FormData();

//       // Add basic fields
//       formData.append('seller_id', userId);
//       formData.append('property_type', isCommercial ? 'commercial' : 'residential');
//       formData.append('category', 'sale');
//       formData.append('location', location.state?.location || '');
//       formData.append('asset_type', assetType || '');
//       formData.append('property_name', location.state?.buildingName || '');
//       formData.append('area_name', location.state?.areaName || '');
//       formData.append('full_address', location.state?.completeAddress || location.state?.full_address || '');

//       const showAreaFields = assetType.toLowerCase() === 'apartment' || selectedType === 'apartment' ||
//         assetType.toLowerCase() === 'independent house' || selectedType === 'independent-house' ||
//         assetType.toLowerCase() === 'duplex' || selectedType === 'duplex';

//       formData.append('carpet_area', showAreaFields ? (location.state?.carpet_area || '') : '');
//       formData.append('carpet_area_units', showAreaFields ? (location.state?.carpet_area_units || '') : '');
//       formData.append('built_up_area', showAreaFields ? (location.state?.built_up_area || '') : '');
//       formData.append('built_up_area_units', showAreaFields ? (location.state?.built_up_area_units || '') : '');
//      formData.append('uds', showAreaFields ? (location.state?.uds_area || '') : '');
// formData.append('uds_units', showAreaFields ? (location.state?.uds_area_units || 'Sq.Ft') : '');

//       const youtubeLink = location.state?.youtubeLink?.trim();
//       formData.append('youtube_link', youtubeLink || null);

//       formData.append('property_size', location.state?.propertySize || '');
//       formData.append('property_size_units', location.state?.property_size_units || location.state?.selectedUnit || '');
//       formData.append('length', location.state?.length || location.state?.propertyLength || '');
//       formData.append('width', location.state?.width || location.state?.propertyWidth || '');

//       formData.append('construction_status', constructionStatus);
//       formData.append('asking_price', Number(askingPrice) || 0);
//       formData.append('negotiable', negotiable);
//       formData.append('currency', currency);
//       formData.append('monthly_rent', null);
//       formData.append('available_from', null);
//       formData.append('security_deposit', null);
//       formData.append('age_of_property', location.state?.age_of_property || '5');

//       if (isplot || isAgricultureLand) {
//         formData.append('locality', null);
//         formData.append('bhk', null);
//         formData.append('furnish_type', null);
//         formData.append('total_floors', null);
//         formData.append('select_floor', null);
//         formData.append('society_aminities', null);
//         formData.append('furnish_facilities', null);
//         formData.append('other_facilities', null);
//         formData.append('facilities_distance', null);

//         if (isplot) {
//           const description = location.state?.propertyDescription || location.state?.description || '';
//           const content = location.state?.propertyContent || location.state?.content || '';
//           formData.append('description', description || null);
//           formData.append('content', content || null);
//         } else {
//           formData.append('description', null);
//           formData.append('content', null);
//         }

//         if (isCommercial) {
//           formData.append('commercial_catgory', 'sale');
//           formData.append('commercial_asset_type', assetType);
//           formData.append('hub', null);
//           formData.append('ownership', null);
//         } else {
//           formData.append('commercial_catgory', null);
//           formData.append('commercial_asset_type', null);
//           formData.append('hub', null);
//           formData.append('ownership', null);
//         }
//       } else {
//         formData.append('locality', location.state?.locality || null);

//         if (!isCommercial) {
//           formData.append('bhk', location.state?.bhk || location.state?.selectedBHK || '');
//           formData.append('furnish_type', location.state?.furnish_type || location.state?.selectedFurnish || '');
//         } else {
//           formData.append('bhk', null);
//           formData.append('furnish_type', null);
//         }

//         formData.append('total_floors', location.state?.totalFloors || location.state?.total_floors || '');
//         formData.append('select_floor', location.state?.selectedFloor || location.state?.select_floor || '');

//         if (!isCommercial && location.state) {
//           const societyAmenities = location.state.society_aminities || '';
//           const furnishFacilities = location.state.furnish_facilities || '';
//           const otherFacilities = location.state.other_facilities || '';

//           formData.append('society_aminities', societyAmenities || null);
//           formData.append('furnish_facilities', furnishFacilities || null);
//           formData.append('other_facilities', otherFacilities || null);
//           formData.append('facilities_distance', location.state?.facilities_distance || '1km');
//         } else {
//           formData.append('society_aminities', null);
//           formData.append('furnish_facilities', null);
//           formData.append('other_facilities', null);
//           formData.append('facilities_distance', null);
//         }

//         if (isCommercial) {
//           formData.append('commercial_catgory', 'sale');
//           formData.append('commercial_asset_type', assetType);
//           formData.append('hub', location.state?.hub || location.state?.selectedHub || '');
//           formData.append('ownership', location.state?.ownership || location.state?.selectedOwnership || 'Freehold');
//         } else {
//           formData.append('commercial_catgory', null);
//           formData.append('commercial_asset_type', null);
//           formData.append('hub', null);
//           formData.append('ownership', null);
//         }
//       }

//       if (location.state?.propertyImages && location.state.propertyImages.length > 0) {
//         location.state.propertyImages.forEach((file) => {
//           formData.append('property_images', file);
//         });
//       }

//       if (location.state?.propertyVideos && location.state.propertyVideos.length > 0) {
//         location.state.propertyVideos.forEach((file) => {
//           formData.append('property_videos', file);
//         });
//       }

//       const response = await fetch('https://propertydealstalk.com/api/property/addProperty', {
//         method: 'POST',
//         body: formData
//       });

//       const data = await response.json();

//       if (data.status === 'SUCCESS') {
//         // ✅ CLEAR ALL FORM DATA - SUCCESS CASE
//         clearAllFormData();

//         if (data.result && data.result.id) {
//           dispatch(addProperty(data.result.id));
//           dispatch(incrementPropertyCount());
//         }

//         setAlert({
//           open: true,
//           message: 'Property added successfully!',
//           severity: 'success'
//         });

//         setTimeout(() => {
//           navigate('/sell-properties');
//         }, 2000);
//       } else {
//         throw new Error(data.message || 'Failed to add property');
//       }
//     } catch (error) {
//       console.error('Error adding property:', error);

//       // ✅ CLEAR ALL FORM DATA - ERROR CASE ALSO
//       clearAllFormData();

//       setAlert({
//         open: true,
//         message: error.message || 'Failed to add property. Please try again.',
//         severity: 'error'
//       });
//     } finally {
//       setLoading(false);
//     }
//   };

//   // Auto-hide popup after a delay
//   useEffect(() => {
//     if (alert.open) {
//       const timer = setTimeout(() => {
//         setAlert({ ...alert, open: false });
//       }, 9000);
//       return () => clearTimeout(timer);
//     }
//   }, [alert.open]);

//   return (
//     <Container maxWidth="lg" sx={{ my: { xs: 4, md: 5 } }}>
//       {loading && <Loader />}

//       <Card sx={{ borderRadius: "20px", border: "1px solid #d0d0d0" }}>
//         <CardContent sx={{ p: { xs: 3, md: 6 } }}>
//           {/* Progress Steps */}
//           <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", mb: 8, flexWrap: "wrap" }}>
//             {progressSteps.map((step, index) => (
//               <React.Fragment key={index}>
//                 <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
//                   <Typography
//                     sx={{
//                       fontFamily: "Outfit, sans-serif",
//                       fontWeight: 400,
//                       color: "text.primary",
//                       fontSize: { xs: "16px", md: "20px" },
//                       mb: 2.5,
//                     }}
//                   >
//                     {step.label}
//                   </Typography>
//                   <Box
//                     sx={{
//                       width: "40px",
//                       height: "40px",
//                       borderRadius: "50%",
//                       border: "3px solid #1a507d",
//                       display: "flex",
//                       alignItems: "center",
//                       justifyContent: "center",
//                       bgcolor: "background.paper",
//                     }}
//                   >
//                     {step.completed ? (
//                       <CheckIcon sx={{ width: "28px", height: "28px", color: "#1a507d" }} />
//                     ) : step.current ? (
//                       <Box sx={{ width: "28px", height: "28px", bgcolor: "#1c274c", borderRadius: "14px" }} />
//                     ) : null}
//                   </Box>
//                 </Box>
//                 {index < progressSteps.length - 1 && (
//                   <Divider sx={{ width: { xs: "50px", md: "147px" }, height: "2px", mx: 2 }} />
//                 )}
//               </React.Fragment>
//             ))}
//           </Box>

//           {/* Form Content */}
//           <Box sx={{ mt: 4 }}>
//             <Typography
//               sx={{
//                 fontFamily: "Outfit, sans-serif",
//                 fontWeight: 500,
//                 color: "text.primary",
//                 fontSize: "25px",
//                 mb: 5,
//               }}
//             >
//               Add Price Details
//             </Typography>

//             {/* Property Cost Field */}
//             <Box sx={{ mb: 5 }}>
//               <Typography
//                 component="label"
//                 sx={{
//                   fontFamily: "Outfit, sans-serif",
//                   fontWeight: 500,
//                   color: "text.secondary",
//                   fontSize: "20px",
//                   display: "block",
//                   mb: 1.5,
//                 }}
//               >
//                 Property Cost <Box component="span" sx={{ color: "#ff0000" }}>*</Box>
//               </Typography>
//               <Box sx={{ position: "relative", width: { xs: "100%", sm: "340px" } }}>
//                 <TextField
//                   placeholder="Enter amount"
//                   value={formatIndianNumber(askingPrice)}
//                   onChange={(e) => {
//                     const value = e.target.value.replace(/,/g, '');
//                     if (value === '' || /^[0-9]*$/.test(value)) {
//                       setAskingPrice(value);
//                       validateAskingPrice(value);
//                     }
//                   }}
//                   error={!!askingPriceError}
//                   helperText={askingPriceError}
//                   sx={{
//                     width: "100%",
//                     "& .MuiInputBase-root": {
//                       height: "70px",
//                       bgcolor: "background.paper",
//                       borderRadius: "10px",
//                       fontFamily: "Outfit, sans-serif",
//                       fontSize: "20px",
//                       paddingRight: "40px",
//                     },
//                   }}
//                 />
//                 <Box
//                   sx={{
//                     position: "absolute",
//                     right: "12px",
//                     top: "50%",
//                     transform: "translateY(-50%)",
//                     color: "#626262",
//                     fontFamily: "Outfit, sans-serif",
//                     fontSize: "20px",
//                     pointerEvents: "none",
//                     zIndex: 1,
//                   }}
//                 >
//                   ₹
//                 </Box>
//               </Box>
//               {/* Display price in words */}
//               {askingPrice && !askingPriceError && (
//                 <Typography
//                   sx={{
//                     fontFamily: "Outfit, sans-serif",
//                     fontSize: "14px",
//                     color: "#4f26ff",
//                     mt: 1,
//                     fontStyle: "italic",
//                   }}
//                 >
//                   {convertToWords(parseInt(askingPrice))}
//                 </Typography>
//               )}
//             </Box>

//             {/* Construction Status Field */}
//             <Box sx={{ mb: 5 }}>
//               <Typography
//                 component="label"
//                 sx={{
//                   fontFamily: "Outfit, sans-serif",
//                   fontWeight: 500,
//                   color: "text.secondary",
//                   fontSize: "20px",
//                   display: "block",
//                   mb: 1.5,
//                 }}
//               >
//                 Construction Status <Box component="span" sx={{ color: "#ff0004" }}>*</Box>
//               </Typography>
//               <Box sx={{ display: "flex", gap: 3, flexDirection: { xs: "column", sm: "row" } }}>
//                 <Button
//                   variant="outlined"
//                   onClick={() => setConstructionStatus('ready to move')}
//                   sx={{
//                     width: { xs: "100%", sm: "340px" },
//                     height: "70px",
//                     bgcolor: constructionStatus === 'ready to move' ? "#eeeaff" : "background.paper",
//                     borderRadius: "10px",
//                     border: "1px solid rgba(0, 0, 0, 0.23)",
//                     fontFamily: "Outfit, sans-serif",
//                     fontWeight: constructionStatus === 'ready to move' ? 500 : 400,
//                     color: constructionStatus === 'ready to move' ? "#4f26ff" : "#626262",
//                     fontSize: "20px",
//                     textTransform: "none",
//                   }}
//                 >
//                   Ready to Move
//                 </Button>
//                 <Button
//                   variant="outlined"
//                   onClick={() => setConstructionStatus('under construction')}
//                   sx={{
//                     width: { xs: "100%", sm: "340px" },
//                     height: "70px",
//                     bgcolor: constructionStatus === 'under construction' ? "#eeeaff" : "background.paper",
//                     borderRadius: "10px",
//                     border: "1px solid rgba(0, 0, 0, 0.23)",
//                     fontFamily: "Outfit, sans-serif",
//                     fontWeight: constructionStatus === 'under construction' ? 500 : 400,
//                     color: constructionStatus === 'under construction' ? "#4f26ff" : "#626262",
//                     fontSize: "20px",
//                     textTransform: "none",
//                   }}
//                 >
//                   Under Construction
//                 </Button>
//               </Box>
//             </Box>

//                            {/* Negotiable Field */}
//                 <Box sx={{ mb: 5 }}>
//                   <Typography
//                     component="label"
//                     sx={{
//                       fontFamily: "Outfit, sans-serif",
//                       fontWeight: 500,
//                       color: "text.secondary",
//                       fontSize: "20px",
//                       display: "block",
//                       mb: 1.5,
//                     }}
//                   >
//                     Is Price Negotiable? <Box component="span" sx={{ color: "#ff0004" }}>*</Box>
//                   </Typography>
//                   <Box sx={{ display: "flex", gap: 3, flexDirection: { xs: "column", sm: "row" } }}>
//                     <Button
//                       variant="outlined"
//                       onClick={() => setNegotiable(true)}
//                       sx={{
//                         width: { xs: "100%", sm: "340px" },
//                         height: "70px",
//                         bgcolor: negotiable ? "#eeeaff" : "background.paper",
//                         borderRadius: "10px",
//                         border: "1px solid rgba(0, 0, 0, 0.23)",
//                         fontFamily: "Outfit, sans-serif",
//                         fontWeight: negotiable ? 500 : 400,
//                         color: negotiable ? "#4f26ff" : "#626262",
//                         fontSize: "20px",
//                         textTransform: "none",
//                       }}
//                     >
//                       Yes
//                     </Button>
//                     <Button
//                       variant="outlined"
//                       onClick={() => setNegotiable(false)}
//                       sx={{
//                         width: { xs: "100%", sm: "340px" },
//                         height: "70px",
//                         bgcolor: !negotiable ? "#eeeaff" : "background.paper",
//                         borderRadius: "10px",
//                         border: "1px solid rgba(0, 0, 0, 0.23)",
//                         fontFamily: "Outfit, sans-serif",
//                         fontWeight: !negotiable ? 500 : 400,
//                         color: !negotiable ? "#4f26ff" : "#626262",
//                         fontSize: "20px",
//                         textTransform: "none",
//                       }}
//                     >
//                       No
//                     </Button>
//                   </Box>
//                 </Box>
//               </Box>

//               {/* Action Buttons */}
//               <Box
//                 sx={{
//                   display: "flex",
//                   justifyContent: "space-between",
//                   mt: { xs: 20, md: 60 },
//                   flexDirection: { xs: "column", sm: "row" },
//                   gap: { xs: 2, sm: 0 },
//                 }}
//               >
//                 <Button
//                   variant="outlined"
//                   onClick={handleBack}
//                   sx={{
//                     width: { xs: "100%", sm: "200px" },
//                     height: "70px",
//                     bgcolor: "#c2c2c2",
//                     borderRadius: "10px",
//                     border: "1px solid rgba(0, 0, 0, 0.23)",
//                     fontFamily: "Outfit, sans-serif",
//                     fontWeight: 400,
//                     color: "#020202",
//                     fontSize: "22px",
//                     textTransform: "none",
//                   }}
//                 >
//                   Back
//                 </Button>
//                 <Button
//                   onClick={handleUploadProperty}
//                   disabled={loading || !!askingPriceError}
//                   sx={{
//                     width: { xs: "100%", sm: "311px" },
//                     height: "70px",
//                     bgcolor: "primary.main",
//                     borderRadius: "10px",
//                     border: "1px solid rgba(0, 0, 0, 0.23)",
//                     fontFamily: "Outfit, sans-serif",
//                     fontWeight: 400,
//                     color: "white",
//                     fontSize: "22px",
//                     textTransform: "none",
//                     '&:disabled': {
//                       bgcolor: '#b0b0b0',
//                       color: '#f5f5f5'
//                     }
//                   }}
//                 >
//                   {loading ? "Uploading..." : "Post Property"}
//                 </Button>
//               </Box>
//             </CardContent>
//           </Card>

//           {/* ✅ Profile Verification Dialog (NO OTP) */}
//           <Dialog
//             open={showVerificationDialog}
//             onClose={() => !verificationLoading && setShowVerificationDialog(false)}
//             maxWidth="sm"
//             fullWidth
//             PaperProps={{
//               sx: {
//                 borderRadius: '16px',
//                 p: 2,
//               }
//             }}
//           >
//             <DialogTitle sx={{
//               fontFamily: 'Outfit',
//               fontWeight: 600,
//               fontSize: '24px',
//               pb: 1
//             }}>
//               Verify Your Details
//             </DialogTitle>
//             <DialogContent>
//               <Typography sx={{
//                 fontFamily: 'Outfit',
//                 fontSize: '14px',
//                 color: '#666',
//                 mb: 3
//               }}>
//                 Please verify your contact information before posting the property
//               </Typography>

//               {/* Full Name */}
//               <Box sx={{ mb: 2 }}>
//                 <Typography sx={{
//                   fontFamily: 'Outfit',
//                   fontSize: '14px',
//                   fontWeight: 500,
//                   mb: 1
//                 }}>
//                   Full Name <span style={{ color: 'red' }}>*</span>
//                 </Typography>
//                 <TextField
//                   fullWidth
//                   placeholder="Enter your full name"
//                   value={verificationForm.fullName}
//                   onChange={(e) => handleVerificationChange('fullName', e.target.value)}
//                   error={!!verificationErrors.fullName}
//                   helperText={verificationErrors.fullName}
//                   disabled={verificationLoading}
//                   InputProps={{
//                     startAdornment: (
//                       <InputAdornment position="start">
//                         <Person sx={{ color: '#666' }} />
//                       </InputAdornment>
//                     ),
//                   }}
//                   sx={{
//                     '& .MuiInputBase-root': {
//                       borderRadius: '8px',
//                       fontFamily: 'Outfit',
//                     }
//                   }}
//                 />
//               </Box>

//               {/* Email */}
//               <Box sx={{ mb: 2 }}>
//                 <Typography sx={{
//                   fontFamily: 'Outfit',
//                   fontSize: '14px',
//                   fontWeight: 500,
//                   mb: 1
//                 }}>
//                   Email Address <span style={{ color: 'red' }}>*</span>
//                 </Typography>
//                 <TextField
//                   fullWidth
//                   type="email"
//                   placeholder="Enter your email"
//                   value={verificationForm.email}
//                   onChange={(e) => handleVerificationChange('email', e.target.value)}
//                   error={!!verificationErrors.email}
//                   helperText={verificationErrors.email}
//                   disabled={verificationLoading}
//                   InputProps={{
//                     startAdornment: (
//                       <InputAdornment position="start">
//                         <Email sx={{ color: '#666' }} />
//                       </InputAdornment>
//                     ),
//                   }}
//                   sx={{
//                     '& .MuiInputBase-root': {
//                       borderRadius: '8px',
//                       fontFamily: 'Outfit',
//                     }
//                   }}
//                 />
//               </Box>

//               {/* Mobile Number */}
//               <Box sx={{ mb: 2 }}>
//                 <Typography sx={{
//                   fontFamily: 'Outfit',
//                   fontSize: '14px',
//                   fontWeight: 500,
//                   mb: 1
//                 }}>
//                   Mobile Number <span style={{ color: 'red' }}>*</span>
//                 </Typography>
//                 <TextField
//                   fullWidth
//                   placeholder="Enter 10-digit mobile number"
//                   value={verificationForm.contactNumber}
//                   onChange={handlePhoneNumberChange}
//                   error={!!verificationErrors.contactNumber}
//                   helperText={verificationErrors.contactNumber}
//                   disabled={verificationLoading}
//                   inputProps={{ maxLength: 10 }}
//                   InputProps={{
//                     startAdornment: (
//                       <InputAdornment position="start">
//                         <Phone sx={{ color: '#666' }} />
//                       </InputAdornment>
//                     ),
//                   }}
//                   sx={{
//                     '& .MuiInputBase-root': {
//                       borderRadius: '8px',
//                       fontFamily: 'Outfit',
//                     }
//                   }}
//                 />
//               </Box>
//             </DialogContent>
//             <DialogActions sx={{ px: 3, pb: 3 }}>
//               <Button
//                 onClick={() => {
//                   if (!verificationLoading) {
//                     setShowVerificationDialog(false);
//                     setVerificationErrors({});
//                   }
//                 }}
//                 disabled={verificationLoading}
//                 sx={{
//                   textTransform: 'none',
//                   fontFamily: 'Outfit',
//                   color: '#666',
//                   borderRadius: '8px',
//                   px: 3,
//                 }}
//               >
//                 Cancel
//               </Button>
//               <Button
//                 onClick={handleVerificationSubmit}
//                 disabled={verificationLoading}
//                 variant="contained"
//                 sx={{
//                   textTransform: 'none',
//                   fontFamily: 'Outfit',
//                   bgcolor: '#4f26ff',
//                   borderRadius: '8px',
//                   px: 3,
//                   '&:hover': {
//                     bgcolor: '#3d1fd9',
//                   },
//                 }}
//               >
//                 {verificationLoading ? (
//                   <CircularProgress size={24} sx={{ color: 'white' }} />
//                 ) : (
//                   'Confirm'
//                 )}
//               </Button>
//             </DialogActions>
//           </Dialog>

//           {/* Alert Dialog */}
//           <Dialog
//             open={alert.open}
//             onClose={() => setAlert({ ...alert, open: false })}
//             PaperProps={{
//               sx: {
//                 borderRadius: "12px",
//                 boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.15)',
//                 maxWidth: "400px",
//                 width: "100%",
//                 margin: '0 16px',
//                 overflow: 'hidden'
//               }
//             }}
//           >
//             <DialogContent sx={{
//               padding: "24px",
//               display: "flex",
//               flexDirection: "column",
//               alignItems: "center",
//               justifyContent: "center",
//               backgroundColor: "#ffffff",
//               minHeight: "180px",
//             }}>
//               <Box sx={{ mb: 2 }}>
//                 {alert.severity === 'success' && (
//                   <CheckIcon sx={{
//                     fontSize: 48,
//                     color: '#2e7d32',
//                     p: 1,
//                     borderRadius: '50%',
//                     backgroundColor: 'rgba(46, 125, 50, 0.1)'
//                   }} />
//                 )}
//                 {alert.severity === 'error' && (
//                   <Box component="span" sx={{
//                     fontSize: 48,
//                     color: '#d32f2f',
//                     p: 1,
//                     borderRadius: '50%',
//                     backgroundColor: 'rgba(211, 47, 47, 0.1)',
//                     display: 'flex',
//                     alignItems: 'center',
//                     justifyContent: 'center'
//                   }}>
//                     ✕
//                   </Box>
//                 )}
//                 {alert.severity === 'warning' && (
//                   <Box component="span" sx={{
//                     fontSize: 48,
//                     color: '#ed6c02',
//                     p: 1,
//                     borderRadius: '50%',
//                     backgroundColor: 'rgba(237, 108, 2, 0.1)',
//                     display: 'flex',
//                     alignItems: 'center',
//                     justifyContent: 'center'
//                   }}>
//                     !
//                   </Box>
//                 )}
//                 {alert.severity === 'info' && (
//                   <Box component="span" sx={{
//                     fontSize: 48,
//                     color: '#0288d1',
//                     p: 1,
//                     borderRadius: '50%',
//                     backgroundColor: 'rgba(2, 136, 209, 0.1)',
//                     display: 'flex',
//                     alignItems: 'center',
//                     justifyContent: 'center'
//                   }}>
//                     i
//                   </Box>
//                 )}
//               </Box>
//               <DialogContentText sx={{
//                 fontFamily: "Outfit, sans-serif",
//                 fontSize: "18px",
//                 textAlign: "center",
//                 color: alert.severity === 'error' ? '#d32f2f' :
//                   alert.severity === 'warning' ? '#ed6c02' :
//                     alert.severity === 'success' ? '#2e7d32' : '#0288d1',
//                 margin: 0,
//                 fontWeight: 500
//               }}>
//                 {alert.message}
//               </DialogContentText>
//             </DialogContent>
//           </Dialog>
//         </Container>
//       );
//     };

//     export default PriceDetails;


import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from 'react-redux';
import { selectUser, addProperty, incrementPropertyCount } from '../Commonlibs/userSlice';
import { useNavigate, useLocation } from 'react-router-dom';
import {
  Box,
  Typography,
  Button,
  TextField,
  Grid,
  InputAdornment,
  CircularProgress,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Select,
  MenuItem,
  FormControl,
} from "@mui/material";
import {
  Check as CheckIcon,
  Phone,
  Email,
  Person,
} from "@mui/icons-material";
import Loader from '../Loader/Loader';
import PostAccess from './PostAccess';

const PriceDetails = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const user = useSelector(selectUser);
  const dispatch = useDispatch();

  // State variables for form data
  const [askingPrice, setAskingPrice] = useState(() => localStorage.getItem('price_askingPrice') || '');
  const [askingPriceError, setAskingPriceError] = useState('');
  const [currency, setCurrency] = useState(() => localStorage.getItem('price_currency') || '₹');
  const [constructionStatus, setConstructionStatus] = useState(() => localStorage.getItem('price_constructionStatus') || 'ready to move');
  const [negotiable, setNegotiable] = useState(() => localStorage.getItem('price_negotiable') === 'false' ? false : true);

  // State for loading and alerts
  const [loading, setLoading] = useState(false);
  const [alert, setAlert] = useState({ open: false, message: '', severity: 'success' });

  // Profile verification states (NO OTP)
  const [profileData, setProfileData] = useState(null);
  const [loadingProfile, setLoadingProfile] = useState(true);
  const [showVerificationDialog, setShowVerificationDialog] = useState(false);
  const [verificationForm, setVerificationForm] = useState({
    fullName: '',
    email: '',
    contactNumber: '',
  });
  const [verificationErrors, setVerificationErrors] = useState({});
  const [verificationLoading, setVerificationLoading] = useState(false);

  // Get data from previous screens
  const { propertyType, category, ...otherProps } = location.state || {};

  // Clear all form data function
  const clearAllFormData = () => {
    setAskingPrice('');
    setCurrency('₹');
    setConstructionStatus('ready to move');
    setNegotiable(true);
    localStorage.removeItem('price_askingPrice');
    localStorage.removeItem('price_currency');
    localStorage.removeItem('price_constructionStatus');
    localStorage.removeItem('price_negotiable');
    localStorage.removeItem('propertyDetailsFormState');
    localStorage.removeItem('propertyType');
    localStorage.removeItem('category');
    localStorage.removeItem('propertyLocation');
     localStorage.removeItem('amenities_society');
  localStorage.removeItem('amenities_furnishing');
  localStorage.removeItem('amenities_other');
  localStorage.removeItem('propertyImagePreviews');
    setAskingPriceError('');
  };

  // Fetch user profile data on mount
  useEffect(() => {
    const fetchUserProfile = async () => {
      const userId = user?.id;
      if (!userId) {
        setLoadingProfile(false);
        return;
      }
      try {
        setLoadingProfile(true);
        const response = await fetch(`https://propertydealstalk.com/api/users/getUserProfile?user_id=${userId}`);
        const data = await response.json();
        if (data.status === "SUCCESS") {
          setProfileData(data.result);
        }
      } catch (err) {
        console.error('Error fetching profile:', err);
      } finally {
        setLoadingProfile(false);
      }
    };
    fetchUserProfile();
  }, [user?.id]);

  // Helper function to format number with Indian comma system
  const formatIndianNumber = (num) => {
    if (!num) return '';
    const numStr = num.toString();
    const lastThree = numStr.substring(numStr.length - 3);
    const otherNumbers = numStr.substring(0, numStr.length - 3);
    if (otherNumbers !== '') {
      return otherNumbers.replace(/\B(?=(\d{2})+(?!\d))/g, ",") + "," + lastThree;
    }
    return lastThree;
  };

  // Helper function to convert number to words (Indian system)
  const convertToWords = (num) => {
    if (!num || num === '0') return '';
    const ones = ['', 'One', 'Two', 'Three', 'Four', 'Five', 'Six', 'Seven', 'Eight', 'Nine'];
    const teens = ['Ten', 'Eleven', 'Twelve', 'Thirteen', 'Fourteen', 'Fifteen', 'Sixteen', 'Seventeen', 'Eighteen', 'Nineteen'];
    const tens = ['', '', 'Twenty', 'Thirty', 'Forty', 'Fifty', 'Sixty', 'Seventy', 'Eighty', 'Ninety'];

    const numToWords = (n) => {
      if (n < 10) return ones[n];
      if (n < 20) return teens[n - 10];
      if (n < 100) return tens[Math.floor(n / 10)] + (n % 10 ? ' ' + ones[n % 10] : '');
      return ones[Math.floor(n / 100)] + ' Hundred' + (n % 100 ? ' ' + numToWords(n % 100) : '');
    };

    const crore = Math.floor(num / 10000000);
    const lakh = Math.floor((num % 10000000) / 100000);
    const thousand = Math.floor((num % 100000) / 1000);
    const hundred = num % 1000;

    let result = '';
    if (crore > 0) result += numToWords(crore) + ' Crore ';
    if (lakh > 0) result += numToWords(lakh) + ' Lakh ';
    if (thousand > 0) result += numToWords(thousand) + ' Thousand ';
    if (hundred > 0) result += numToWords(hundred);

    return result.trim();
  };
const handleBack = () => {
  const assetType = location.state?.asset_type || '';
  const selectedType = location.state?.selectedType || '';
  const isPlot = assetType === 'plot' || selectedType === 'plot';
  const isAgricultureLand = assetType?.toLowerCase() === 'agriculture land' || selectedType === 'agriculture-land';
  const isCommercial = propertyType === 'Commercial';

  // ✅ Determine if amenities should be shown
  const shouldShowAmenities = !isCommercial && !isPlot && !isAgricultureLand;

  if (shouldShowAmenities) {
    // Navigate back to Amenities
    navigate('/amenities', {
      state: {
        propertyType: propertyType || location.state?.propertyType,
        category: category || location.state?.category,
        location: location.state?.location || '',
        asset_type: location.state?.asset_type || '',
        selectedType: location.state?.selectedType || '',
        ...location.state
      }
    });
  } else {
    // Skip Amenities, go directly to Property Details
    navigate('/property-details', {
      state: {
        propertyType: propertyType || location.state?.propertyType,
        category: category || location.state?.category,
        location: location.state?.location || '',
        asset_type: location.state?.asset_type || '',
        selectedType: location.state?.selectedType || '',
        ...location.state
      }
    });
  }
};

  // Save form values to localStorage whenever they change
  useEffect(() => {
    localStorage.setItem('price_askingPrice', askingPrice);
    localStorage.setItem('price_currency', currency);
    localStorage.setItem('price_constructionStatus', constructionStatus);
    localStorage.setItem('price_negotiable', negotiable.toString());
  }, [askingPrice, currency, constructionStatus, negotiable]);

  // Validate asking price
  const validateAskingPrice = (value) => {
    if (!value || value.trim() === '') {
      setAskingPriceError('Property cost is required');
      return false;
    }
    const priceRegex = /^[1-9]\d*$/;
    if (!priceRegex.test(value)) {
      setAskingPriceError('Please enter a valid whole number amount (e.g., 5000000)');
      return false;
    }
    const amount = parseInt(value, 10);
    if (amount < 100000) {
      setAskingPriceError('Property cost must be at least 1 lakh');
      return false;
    }
    if (amount > 10000000000) {
      setAskingPriceError('Property cost cannot exceed 1000 crores');
      return false;
    }
    setAskingPriceError('');
    return true;
  };

  // Handle asking price change with input validation
  const handleAskingPriceChange = (e) => {
    const value = e.target.value;
    if (value === '' || /^[0-9]*$/.test(value)) {
      setAskingPrice(value);
      validateAskingPrice(value);
    }
  };

  // Validation functions for verification form
  const validateVerificationField = (name, value) => {
    if (!value || value.trim() === '' || value === 'N/A') {
      return `${name} is required`;
    }
    switch (name) {
      case 'fullName':
        return /^[A-Za-z\s]{2,50}$/.test(value)
          ? ''
          : 'Name should contain only letters and spaces (2-50 characters)';
      case 'email':
        return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)
          ? ''
          : 'Please enter a valid email address';
      case 'contactNumber':
        return /^\d{10}$/.test(value)
          ? ''
          : 'Phone number should be 10 digits';
      default:
        return '';
    }
  };

  // Handle verification form changes
  const handleVerificationChange = (field, value) => {
    setVerificationForm(prev => ({ ...prev, [field]: value }));
    if (verificationErrors[field]) {
      setVerificationErrors(prev => ({ ...prev, [field]: '' }));
    }
  };

  // Handle phone number input (only digits)
  const handlePhoneNumberChange = (e) => {
    const value = e.target.value;
    if (value === '' || (/^\d+$/.test(value) && value.length <= 10)) {
      handleVerificationChange('contactNumber', value);
    }
  };

  // Update user profile (NO OTP - Direct Update)
  const updateUserProfile = async () => {
    setVerificationLoading(true);
    try {
      const formDataToSend = new FormData();
      formDataToSend.append('user_id', user?.id);
      formDataToSend.append('full_name', verificationForm.fullName);
      formDataToSend.append('email_id', verificationForm.email);
      formDataToSend.append('contact_number', verificationForm.contactNumber);

      const response = await fetch('https://propertydealstalk.com/api/users/UpdateUserprofile', {
        method: 'POST',
        body: formDataToSend,
      });

      const data = await response.json();

      if (data.status === "SUCCESS") {
        setProfileData(data.result);
        setShowVerificationDialog(false);
        setTimeout(() => {
          performPropertyUpload();
        }, 500);
      } else {
        setAlert({
          open: true,
          message: data.message || 'Failed to update profile',
          severity: 'error'
        });
      }
    } catch (error) {
      console.error('Profile update error:', error);
      setAlert({
        open: true,
        message: 'Failed to update profile. Please try again.',
        severity: 'error'
      });
    } finally {
      setVerificationLoading(false);
    }
  };

  // Handle verification submit (Direct - No OTP)
  const handleVerificationSubmit = async () => {
    const newErrors = {};
    Object.keys(verificationForm).forEach(key => {
      const error = validateVerificationField(key, verificationForm[key]);
      if (error) newErrors[key] = error;
    });

    if (Object.keys(newErrors).length > 0) {
      setVerificationErrors(newErrors);
      return;
    }

    await updateUserProfile();
  };

  // Handle property upload - check profile first
  const handleUploadProperty = async () => {
    const isPriceValid = validateAskingPrice(askingPrice);

    if (!isPriceValid) {
      setAlert({
        open: true,
        message: 'Please fix the errors before submitting',
        severity: 'error'
      });
      return;
    }

    // Check if user profile needs verification
    const needsVerification =
      !profileData?.full_name ||
      profileData.full_name === 'N/A' ||
      !profileData?.email_id ||
      profileData.email_id === 'N/A' ||
      !profileData?.contact_number ||
      profileData.contact_number === 'N/A';

    if (needsVerification) {
      setVerificationForm({
        fullName: profileData?.full_name && profileData.full_name !== 'N/A' ? profileData.full_name : '',
        email: profileData?.email_id && profileData.email_id !== 'N/A' ? profileData.email_id : '',
        contactNumber: profileData?.contact_number && profileData.contact_number !== 'N/A' ? profileData.contact_number : '',
      });
      setShowVerificationDialog(true);
      return;
    }

    await performPropertyUpload();
  };

  // Actual property upload logic
  const performPropertyUpload = async () => {
    setLoading(true);

    try {
      if (!askingPrice || !currency || !constructionStatus) {
        setAlert({
          open: true,
          message: 'Please fill all required fields',
          severity: 'error'
        });
        setLoading(false);
        return;
      }

      const userId = user?.id;
      if (!userId) {
        throw new Error('User not authenticated');
      }

      const assetType = location.state?.asset_type || '';
      const selectedType = location.state?.selectedType || '';
      const isplot = assetType === 'plot' || selectedType === 'plot';
      const isAgricultureLand = assetType.toLowerCase() === 'agriculture land' || selectedType === 'agriculture-land';
      const isCommercial = propertyType === 'Commercial';

      const formData = new FormData();
      formData.append('seller_id', userId);
      formData.append('property_type', isCommercial ? 'commercial' : 'residential');
      formData.append('category', 'sale');
      formData.append('location', location.state?.location || '');
      formData.append('asset_type', assetType || '');
      formData.append('property_name', location.state?.buildingName || '');
      formData.append('area_name', location.state?.areaName || '');
      formData.append('full_address', location.state?.completeAddress || location.state?.full_address || '');

      const showAreaFields = assetType.toLowerCase() === 'apartment' || selectedType === 'apartment' ||
        assetType.toLowerCase() === 'independent house' || selectedType === 'independent-house' ||
        assetType.toLowerCase() === 'duplex' || selectedType === 'duplex';

      formData.append('carpet_area', showAreaFields ? (location.state?.carpet_area || '') : '');
      formData.append('carpet_area_units', showAreaFields ? (location.state?.carpet_area_units || '') : '');
      formData.append('built_up_area', showAreaFields ? (location.state?.built_up_area || '') : '');
      formData.append('built_up_area_units', showAreaFields ? (location.state?.built_up_area_units || '') : '');
      formData.append('uds', showAreaFields ? (location.state?.uds_area || '') : '');
      formData.append('uds_units', showAreaFields ? (location.state?.uds_area_units || 'Sq.Ft') : '');

      const youtubeLink = location.state?.youtubeLink?.trim();
      formData.append('youtube_link', youtubeLink || null);

      formData.append('property_size', location.state?.propertySize || '');
      formData.append('property_size_units', location.state?.property_size_units || location.state?.selectedUnit || '');
      formData.append('length', location.state?.length || location.state?.propertyLength || '');
      formData.append('width', location.state?.width || location.state?.propertyWidth || '');
      formData.append('construction_status', constructionStatus);
      formData.append('asking_price', Number(askingPrice) || 0);
      formData.append('negotiable', negotiable);
      formData.append('currency', currency);
      formData.append('monthly_rent', null);
      formData.append('available_from', null);
      formData.append('security_deposit', null);
      formData.append('age_of_property', location.state?.age_of_property || '5');

      if (isplot || isAgricultureLand) {
        formData.append('locality', null);
        formData.append('bhk', null);
        formData.append('furnish_type', null);
        formData.append('total_floors', null);
        formData.append('select_floor', null);
        formData.append('society_aminities', null);
        formData.append('furnish_facilities', null);
        formData.append('other_facilities', null);
        formData.append('facilities_distance', null);

        if (isplot) {
          const description = location.state?.propertyDescription || location.state?.description || '';
          const content = location.state?.propertyContent || location.state?.content || '';
          formData.append('description', description || null);
          formData.append('content', content || null);
        } else {
          formData.append('description', null);
          formData.append('content', null);
        }

        if (isCommercial) {
          formData.append('commercial_catgory', 'sale');
          formData.append('commercial_asset_type', assetType);
          formData.append('hub', null);
          formData.append('ownership', null);
        } else {
          formData.append('commercial_catgory', null);
          formData.append('commercial_asset_type', null);
          formData.append('hub', null);
          formData.append('ownership', null);
        }
      } else {
        formData.append('locality', location.state?.locality || null);

        if (!isCommercial) {
          formData.append('bhk', location.state?.bhk || location.state?.selectedBHK || '');
          formData.append('furnish_type', location.state?.furnish_type || location.state?.selectedFurnish || '');
        } else {
          formData.append('bhk', null);
          formData.append('furnish_type', null);
        }

        formData.append('total_floors', location.state?.totalFloors || location.state?.total_floors || '');
        formData.append('select_floor', location.state?.selectedFloor || location.state?.select_floor || '');

        if (!isCommercial && location.state) {
          const societyAmenities = location.state.society_aminities || '';
          const furnishFacilities = location.state.furnish_facilities || '';
          const otherFacilities = location.state.other_facilities || '';

          formData.append('society_aminities', societyAmenities || null);
          formData.append('furnish_facilities', furnishFacilities || null);
          formData.append('other_facilities', otherFacilities || null);
          formData.append('facilities_distance', location.state?.facilities_distance || '1km');
        } else {
          formData.append('society_aminities', null);
          formData.append('furnish_facilities', null);
          formData.append('other_facilities', null);
          formData.append('facilities_distance', null);
        }

        if (isCommercial) {
          formData.append('commercial_catgory', 'sale');
          formData.append('commercial_asset_type', assetType);
          formData.append('hub', location.state?.hub || location.state?.selectedHub || '');
          formData.append('ownership', location.state?.ownership || location.state?.selectedOwnership || 'Freehold');
        } else {
          formData.append('commercial_catgory', null);
          formData.append('commercial_asset_type', null);
          formData.append('hub', null);
          formData.append('ownership', null);
        }
      }

      if (location.state?.propertyImages && location.state.propertyImages.length > 0) {
        location.state.propertyImages.forEach((file) => {
          formData.append('property_images', file);
        });
      }

      if (location.state?.propertyVideos && location.state.propertyVideos.length > 0) {
        location.state.propertyVideos.forEach((file) => {
          formData.append('property_videos', file);
        });
      }

      const response = await fetch('https://propertydealstalk.com/api/property/addProperty', {
        method: 'POST',
        body: formData
      });

      const data = await response.json();

      if (data.status === 'SUCCESS') {
        clearAllFormData();

        if (data.result && data.result.id) {
          dispatch(addProperty(data.result.id));
          dispatch(incrementPropertyCount());
        }

        setAlert({
          open: true,
          message: 'Property added successfully!',
          severity: 'success'
        });

        setTimeout(() => {
          navigate('/sell-properties');
        }, 2000);
      } else {
        throw new Error(data.message || 'Failed to add property');
      }
    } catch (error) {
      console.error('Error adding property:', error);
      clearAllFormData();
      setAlert({
        open: true,
        message: error.message || 'Failed to add property. Please try again.',
        severity: 'error'
      });
    } finally {
      setLoading(false);
    }
  };

  // Auto-hide popup after a delay
  useEffect(() => {
    if (alert.open) {
      const timer = setTimeout(() => {
        setAlert({ ...alert, open: false });
      }, 9000);
      return () => clearTimeout(timer);
    }
  }, [alert.open]);

  return (
    <PostAccess
      currentStep={3}
      category={category}
      propertyType={propertyType}
      assetType={location.state?.asset_type || ''}
    >
      {loading && <Loader />}

      <Box
        sx={{
          flex: 1,
          maxWidth: { xs: '100%', md: '800px' },
          p: { xs: 2.5, sm: 3, md: 3.5 },
          backgroundColor: '#ffffff',
          borderRadius: 2,
          border: '1px solid #e0e0e0',
        }}
      >
        <Typography
          variant="h5"
          sx={{
            fontFamily: 'Outfit',
            fontWeight: 600,
            mb: 0.5,
            fontSize: { xs: '18px', md: '22px' },
          }}
        >
          Add Price Details
        </Typography>

        <Typography
          sx={{
            fontFamily: 'Outfit',
            fontSize: '13px',
            color: '#666',
            mb: 3,
          }}
        >
          Complete all required fields
        </Typography>

        {/* Form Content */}
        <Box sx={{ mt: 4 }}>
          {/* All Three Fields in Single Line with 270px width each */}
          <Box sx={{ display: 'flex', gap: 2, flexWrap: 'wrap', mb: 4 }}>
            {/* Property Cost */}
            <Box sx={{ width: '215px' }}>
              <Typography
                component="label"
                sx={{
                  fontFamily: "Outfit, sans-serif",
                  fontWeight: 500,
                  color: "text.secondary",
                  fontSize: "16px",
                  display: "block",
                  mb: 1.5,
                }}
              >
                Property Cost <Box component="span" sx={{ color: "#ff0000" }}>*</Box>
              </Typography>
              <TextField
                placeholder="Enter amount"
                value={formatIndianNumber(askingPrice)}
                onChange={(e) => {
                  const value = e.target.value.replace(/,/g, '');
                  if (value === '' || /^[0-9]*$/.test(value)) {
                    setAskingPrice(value);
                    validateAskingPrice(value);
                  }
                }}
                error={!!askingPriceError}
                helperText={askingPriceError}
                InputProps={{
                  endAdornment: <InputAdornment position="end">₹</InputAdornment>,
                }}
                sx={{
                  width: "100%",
                  "& .MuiInputBase-root": {
                    height: "50px",
                    bgcolor: "background.paper",
                    borderRadius: "10px",
                    fontFamily: "Outfit, sans-serif",
                    fontSize: "15px",
                  },
                }}
              />
              {askingPrice && !askingPriceError && (
                <Typography
                  sx={{
                    fontFamily: "Outfit, sans-serif",
                    fontSize: "12px",
                    color: "#4f26ff",
                    mt: 0.5,
                    fontStyle: "italic",
                  }}
                >
                  {convertToWords(parseInt(askingPrice))}
                </Typography>
              )}
            </Box>

            {/* Construction Status Dropdown */}
            <Box sx={{ width: '215px' }}>
              <Typography
                component="label"
                sx={{
                  fontFamily: "Outfit, sans-serif",
                  fontWeight: 500,
                  color: "text.secondary",
                  fontSize: "16px",
                  display: "block",
                  mb: 1.5,
                }}
              >
                Construction Status <Box component="span" sx={{ color: "#ff0004" }}>*</Box>
              </Typography>
              <FormControl fullWidth>
                <Select
                  value={constructionStatus}
                  onChange={(e) => setConstructionStatus(e.target.value)}
                  sx={{
                    height: "50px",
                    borderRadius: "10px",
                    fontFamily: "Outfit, sans-serif",
                    fontSize: "15px",
                    bgcolor: "white",
                  }}
                >
                  <MenuItem value="ready to move" sx={{ fontFamily: "Outfit, sans-serif" }}>
                    Ready to Move
                  </MenuItem>
                  <MenuItem value="under construction" sx={{ fontFamily: "Outfit, sans-serif" }}>
                    Under Construction
                  </MenuItem>
                </Select>
              </FormControl>
            </Box>

            {/* Price Negotiable Dropdown */}
            <Box sx={{ width: '215px' }}>
              <Typography
                component="label"
                sx={{
                  fontFamily: "Outfit, sans-serif",
                  fontWeight: 500,
                  color: "text.secondary",
                  fontSize: "16px",
                  display: "block",
                  mb: 1.5,
                }}
              >
                Price Negotiable? <Box component="span" sx={{ color: "#ff0004" }}>*</Box>
              </Typography>
              <FormControl fullWidth>
                <Select
                  value={negotiable}
                  onChange={(e) => setNegotiable(e.target.value)}
                  sx={{
                    height: "50px",
                    borderRadius: "10px",
                    fontFamily: "Outfit, sans-serif",
                    fontSize: "15px",
                    bgcolor: "white",
                  }}
                >
                  <MenuItem value={true} sx={{ fontFamily: "Outfit, sans-serif" }}>
                    Yes
                  </MenuItem>
                  <MenuItem value={false} sx={{ fontFamily: "Outfit, sans-serif" }}>
                    No
                  </MenuItem>
                </Select>
              </FormControl>
            </Box>
          </Box>
        </Box>

        {/* Action Buttons */}
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            mt: 6,
            gap: 2,
          }}
        >
          <Button
            variant="outlined"
            onClick={handleBack}
            sx={{
              px: 3,
              py: 1.2,
              borderRadius: 1.5,
              textTransform: "none",
              fontFamily: "Outfit",
              fontSize: "14px",
              color: "#666",
              borderColor: "#e0e0e0",
              minWidth: "100px",
            }}
          >
            Back
          </Button>

          <Button
            onClick={handleUploadProperty}
            disabled={loading || !!askingPriceError}
            sx={{
              px: 3,
              py: 1.2,
              borderRadius: 1.5,
              textTransform: "none",
              fontFamily: "Outfit",
              fontSize: "14px",
              backgroundColor: "#1976d2",
              color: "white",
              minWidth: "150px",
              '&:hover': {
                backgroundColor: "#1565c0",
              },
              '&:disabled': {
                bgcolor: '#b0b0b0',
                color: '#f5f5f5'
              }
            }}
          >
            {loading ? "Uploading..." : "Post Property"}
          </Button>
        </Box>
      </Box>

      {/* Profile Verification Dialog (NO OTP) */}
      <Dialog
        open={showVerificationDialog}
        onClose={() => !verificationLoading && setShowVerificationDialog(false)}
        maxWidth="sm"
        fullWidth
        PaperProps={{
          sx: {
            borderRadius: '16px',
            p: 2,
          }
        }}
      >
        <DialogTitle sx={{
          fontFamily: 'Outfit',
          fontWeight: 600,
          fontSize: '24px',
          pb: 1
        }}>
          Verify Your Details
        </DialogTitle>

        <DialogContent>
          <Typography sx={{
            fontFamily: 'Outfit',
            fontSize: '14px',
            color: '#666',
            mb: 3
          }}>
            Please verify your contact information before posting the property
          </Typography>

          {/* Full Name */}
          <Box sx={{ mb: 2 }}>
            <Typography sx={{
              fontFamily: 'Outfit',
              fontSize: '14px',
              fontWeight: 500,
              mb: 1
            }}>
              Full Name <span style={{ color: 'red' }}>*</span>
            </Typography>
            <TextField
              fullWidth
              placeholder="Enter your full name"
              value={verificationForm.fullName}
              onChange={(e) => handleVerificationChange('fullName', e.target.value)}
              error={!!verificationErrors.fullName}
              helperText={verificationErrors.fullName}
              disabled={verificationLoading}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <Person sx={{ color: '#666' }} />
                  </InputAdornment>
                ),
              }}
              sx={{
                '& .MuiInputBase-root': {
                  borderRadius: '8px',
                  fontFamily: 'Outfit',
                }
              }}
            />
          </Box>

          {/* Email */}
          <Box sx={{ mb: 2 }}>
            <Typography sx={{
              fontFamily: 'Outfit',
              fontSize: '14px',
              fontWeight: 500,
              mb: 1
            }}>
              Email Address <span style={{ color: 'red' }}>*</span>
            </Typography>
            <TextField
              fullWidth
              type="email"
              placeholder="Enter your email"
              value={verificationForm.email}
              onChange={(e) => handleVerificationChange('email', e.target.value)}
              error={!!verificationErrors.email}
              helperText={verificationErrors.email}
              disabled={verificationLoading}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <Email sx={{ color: '#666' }} />
                  </InputAdornment>
                ),
              }}
              sx={{
                '& .MuiInputBase-root': {
                  borderRadius: '8px',
                  fontFamily: 'Outfit',
                }
              }}
            />
          </Box>

          {/* Mobile Number */}
          <Box sx={{ mb: 2 }}>
            <Typography sx={{
              fontFamily: 'Outfit',
              fontSize: '14px',
              fontWeight: 500,
              mb: 1
            }}>
              Mobile Number <span style={{ color: 'red' }}>*</span>
            </Typography>
            <TextField
              fullWidth
              placeholder="Enter 10-digit mobile number"
              value={verificationForm.contactNumber}
              onChange={handlePhoneNumberChange}
              error={!!verificationErrors.contactNumber}
              helperText={verificationErrors.contactNumber}
              disabled={verificationLoading}
              inputProps={{ maxLength: 10 }}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <Phone sx={{ color: '#666' }} />
                  </InputAdornment>
                ),
              }}
              sx={{
                '& .MuiInputBase-root': {
                  borderRadius: '8px',
                  fontFamily: 'Outfit',
                }
              }}
            />
          </Box>
        </DialogContent>

        <DialogActions sx={{ px: 3, pb: 3 }}>
          <Button
            onClick={() => {
              if (!verificationLoading) {
                setShowVerificationDialog(false);
                setVerificationErrors({});
              }
            }}
            disabled={verificationLoading}
            sx={{
              textTransform: 'none',
              fontFamily: 'Outfit',
              color: '#666',
              borderRadius: '8px',
              px: 3,
            }}
          >
            Cancel
          </Button>

          <Button
            onClick={handleVerificationSubmit}
            disabled={verificationLoading}
            variant="contained"
            sx={{
              textTransform: 'none',
              fontFamily: 'Outfit',
              bgcolor: '#4f26ff',
              borderRadius: '8px',
              px: 3,
              '&:hover': {
                bgcolor: '#3d1fd9',
              },
            }}
          >
            {verificationLoading ? (
              <CircularProgress size={24} sx={{ color: 'white' }} />
            ) : (
              'Confirm'
            )}
          </Button>
        </DialogActions>
      </Dialog>

      {/* Alert Dialog */}
      <Dialog
        open={alert.open}
        onClose={() => setAlert({ ...alert, open: false })}
        PaperProps={{
          sx: {
            borderRadius: "12px",
            boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.15)',
            maxWidth: "400px",
            width: "100%",
            margin: '0 16px',
            overflow: 'hidden'
          }
        }}
      >
        <DialogContent sx={{
          padding: "24px",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          backgroundColor: "#ffffff",
          minHeight: "180px",
        }}>
          <Box sx={{ mb: 2 }}>
            {alert.severity === 'success' && (
              <CheckIcon sx={{
                fontSize: 48,
                color: '#2e7d32',
                p: 1,
                borderRadius: '50%',
                backgroundColor: 'rgba(46, 125, 50, 0.1)'
              }} />
            )}
            {alert.severity === 'error' && (
              <Box component="span" sx={{
                fontSize: 48,
                color: '#d32f2f',
                p: 1,
                borderRadius: '50%',
                backgroundColor: 'rgba(211, 47, 47, 0.1)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
              }}>
                ✕
              </Box>
            )}
            {alert.severity === 'warning' && (
              <Box component="span" sx={{
                fontSize: 48,
                color: '#ed6c02',
                p: 1,
                borderRadius: '50%',
                backgroundColor: 'rgba(237, 108, 2, 0.1)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
              }}>
                !
              </Box>
            )}
            {alert.severity === 'info' && (
              <Box component="span" sx={{
                fontSize: 48,
                color: '#0288d1',
                p: 1,
                borderRadius: '50%',
                backgroundColor: 'rgba(2, 136, 209, 0.1)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
              }}>
                i
              </Box>
            )}
          </Box>

          <DialogContentText sx={{
            fontFamily: "Outfit, sans-serif",
            fontSize: "18px",
            textAlign: "center",
            color: alert.severity === 'error' ? '#d32f2f' :
              alert.severity === 'warning' ? '#ed6c02' :
                alert.severity === 'success' ? '#2e7d32' : '#0288d1',
            margin: 0,
            fontWeight: 500
          }}>
            {alert.message}
          </DialogContentText>
        </DialogContent>
      </Dialog>
    </PostAccess>
  );
};

export default PriceDetails;